module.exports = __webpack_public_path__ + "static/media/r7.a39e2bb7.jpg";